import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import useAuth from "../../hooks/useAuthContext"
import { toast } from "react-toastify";
import Loader from "../../components/utilities/Loader/Loader";
import axiosInstance from "../../hooks/axiosInstance";

export default function SuperAdminDashboardPage() {
    const {userData} = useAuth()
    const navigate = useNavigate()

    const [associationAnalytics, setAssociationAnalytics] = useState([]);
    const [loading, setLoading] = useState(false);
    const [associations, setAssociations] = useState([])
    const [currentAssociation, setCurrentAssociation] = useState(null)
     //  state for pagination
     const [page, setPage] = useState(1);
     const [perPage, setPerPage] = useState(10);
     const [pageCount, setPageCount] = useState(1);

     const [filter, setFilter] = useState({
        search: '', status: ''
    })

     const fetchAssociationAnalytics = () => {
        setLoading(true);
        axiosInstance
        .get(`/admin/dashboard/analytics`)
        .then((response) => {
            setAssociationAnalytics(response.data.data.admin_analytics);
        })
        .catch((err) => {
            toast.error("An error occured. Please, try again");
        })
        .finally(() => setLoading(false));
    };

    const fetchAssociations = () => {
        setLoading(true)
        axiosInstance.post(`/admin/associations?page=${page}`, filter)
              .then(response => {
                setAssociations(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    useEffect(() => {
        fetchAssociationAnalytics()
        fetchAssociations()
    }, [])

    return (
        <>
            <div className="row">
                <div className="col">

                    <div className="h-100">
                        <div className="row mb-3 pb-1">
                            <div className="col-12">
                                <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                                    <div className="flex-grow-1">
                                        <h4 className="fs-16 mb-1">Welcome, <span className="text-info font-weight-bold">{userData?.userInfo?.last_name}</span></h4>
                                        <p className="text-muted mb-0">Here's what's happening with your associations
                                            today.</p>
                                    </div>
                                </div>
                                {/* <!-- end card header --> */}
                            </div>
                            {/* <!--end col--> */}
                        </div>
                        {/* <!--end row--> */}

                        <div className="row row-cols-xxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1">
                            <div className="col">
                                <div className="card">
                                    <div className="card-body d-flex">
                                        <div className="flex-grow-1">
                                            <h4>{associationAnalytics?.total_users}</h4>
                                            <h6 className="text-muted fs-13 mb-0">Users</h6>
                                        </div>
                                        <div className="flex-shrink-0 avatar-sm">
                                            <div className="avatar-title bg-warning-subtle text-warning fs-22 rounded">
                                                <i className="ri-upload-2-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end col--> */}
                            <div className="col">
                                <div className="card">
                                    <div className="card-body d-flex">
                                        <div className="flex-grow-1">
                                            <h4>{associationAnalytics?.total_associations}</h4>
                                            <h6 className="text-muted fs-13 mb-0">Associations</h6>
                                        </div>
                                        <div className="flex-shrink-0 avatar-sm">
                                            <div className="avatar-title bg-success-subtle text-success fs-22 rounded">
                                                <i className="ri-remote-control-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end col--> */}
                            <div className="col">
                                <div className="card">
                                    <div className="card-body d-flex">
                                        <div className="flex-grow-1">
                                            <h4>{associationAnalytics?.total_members}</h4>
                                            <h6 className="text-muted fs-13 mb-0">Members</h6>
                                        </div>
                                        <div className="flex-shrink-0 avatar-sm">
                                            <div className="avatar-title bg-info-subtle text-info fs-22 rounded">
                                                <i className="ri-flashlight-fill"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col">
                                <div className="card">
                                    <div className="card-body d-flex">
                                        <div className="flex-grow-1">
                                            <h4>₦35,400</h4>
                                            <h6 className="text-muted fs-13 mb-0">Outstanding Dues</h6>
                                        </div>
                                        <div className="flex-shrink-0 avatar-sm">
                                            <div className="avatar-title bg-info-subtle text-info fs-22 rounded">
                                                <i className="ri-flashlight-fill"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="col">
                                <div className="card">
                                    <div className="card-body d-flex">
                                        <div className="flex-grow-1">
                                            <h4>{associationAnalytics?.total_dues}</h4>
                                            <h6 className="text-muted fs-13 mb-0">Active Dues</h6>
                                        </div>
                                        <div className="flex-shrink-0 avatar-sm">
                                            <div className="avatar-title bg-info-subtle text-info fs-22 rounded">
                                                <i className="ri-flashlight-fill"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* <!--end col--> */}
                            {/* <div className="col">
                                <div className="card">
                                    <div className="card-body d-flex">
                                        <div className="flex-grow-1">
                                            <h4>2762</h4>
                                            <h6 className="text-muted fs-13 mb-0">Paid-Up Members</h6>
                                        </div>
                                        <div className="flex-shrink-0 avatar-sm">
                                            <div className="avatar-title bg-danger-subtle text-danger fs-22 rounded">
                                                <i className="ri-hand-coin-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!--end col--> */}
                            {/* <div className="col">
                                <div className="card">
                                    <div className="card-body d-flex">
                                        <div className="flex-grow-1">
                                            <h4>1585</h4>
                                            <h6 className="text-muted fs-13 mb-0">Owing Members</h6>
                                        </div>
                                        <div className="flex-shrink-0 avatar-sm">
                                            <div className="avatar-title bg-primary-subtle text-primary fs-22 rounded">
                                                <i className="ri-donut-chart-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!--end col--> */}
                        </div>
                        {/* <!-- end row--> */}

                        <div className="row">
                            <div className="col-xl-7 col-md-6">
                                <div className="card card-height-100">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">News Feed</h4>
                                        <div>
                                            {/* <button type="button" className="btn btn-soft-primary btn-sm">
                                                View all
                                            </button> */}
                                        </div>
                                    </div>{/* <!-- end card-header --> */}

                                    <div className="card-body">
                                        {1 == 0 ?
                                            <>
                                                <div className="d-flex align-middle">
                                                    <div className="flex-shrink-0">
                                                        <img src="/assets/images/small/img-1.jpg" className="rounded img-fluid" style={{height: "60px"}} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1 lh-base"><a href="#" className="text-reset">One stop shop destination on all the latest news in crypto currencies</a></h6>
                                                        <p className="text-muted fs-12 mb-0">Dec 12, 2021 <i className="mdi mdi-circle-medium align-middle mx-1"></i>09:22 AM</p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="d-flex mt-4">
                                                    <div className="flex-shrink-0">
                                                        <img src="/assets/images/small/img-2.jpg" className="rounded img-fluid" style={{height: "60px"}} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1 lh-base"><a href="#" className="text-reset">Coin Journal is dedicated to delivering stories on the latest crypto</a></h6>
                                                        <p className="text-muted fs-12 mb-0">Dec 03, 2021 <i className="mdi mdi-circle-medium align-middle mx-1"></i>12:09 PM</p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="d-flex mt-4">
                                                    <div className="flex-shrink-0">
                                                        <img src="/assets/images/small/img-3.jpg" className="rounded img-fluid" style={{height: "60px"}} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1 lh-base"><a href="#" className="text-reset">The bitcoin-holding U.S. senator is trying to “fully integrate” crypto </a></h6>
                                                        <p className="text-muted fs-12 mb-0">Nov 22, 2021 <i className="mdi mdi-circle-medium align-middle mx-1"></i>11:47 AM</p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="d-flex mt-4">
                                                    <div className="flex-shrink-0">
                                                        <img src="/assets/images/small/img-6.jpg" className="rounded img-fluid" style={{height: "60px"}} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1 lh-base"><a href="#" className="text-reset">Cryptocurrency price like Bitcoin, Dash, Dogecoin, Ripple and Litecoin</a></h6>
                                                        <p className="text-muted fs-12 mb-0">Nov 18, 2021 <i className="mdi mdi-circle-medium align-middle mx-1"></i>06:13 PM</p>
                                                    </div>
                                                </div>{/* <!-- end --> */}

                                                <div className="mt-3 text-center">
                                                    <a href="javascript:void(0);" className="text-muted text-decoration-underline">View all News</a>
                                                </div>
                                            </>
                                        :
                                            <div className="noresult">
                                                <div className="text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                                    <h5 className="mt-2">Sorry! No News Found</h5>
                                                    {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {/* <!-- end card body --> */}
                                </div>
                                {/* <!-- end card --> */}
                            </div>
                            {/* <!-- end col --> */}

                            <div className="col-xxl-5 col-md-6">
                                <div className="card">
                                    <div className="card-header border-0">
                                        <h4 className="card-title mb-0">Upcoming Events</h4>
                                    </div>{/* <!-- end cardheader --> */}
                                    <div className="card-body pt-0">
                                        {1 == 0 ?
                                            <>
                                                {/* <h6 className="text-uppercase fw-semibold mt-4 mb-3 text-muted">Events:</h6> */}
                                                <div className="mini-stats-wid d-flex align-items-center mt-3">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                                            09
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1">Development planning</h6>
                                                        <p className="text-muted mb-0">September, 2023 </p>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <p className="text-muted mb-0">9:20 <span className="text-uppercase">am</span></p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="mini-stats-wid d-flex align-items-center mt-3">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                                            12
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1">Design new UI and check sales</h6>
                                                        <p className="text-muted mb-0">January, 2024</p>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <p className="text-muted mb-0">11:30 <span className="text-uppercase">am</span></p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="mini-stats-wid d-flex align-items-center mt-3">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                                            25
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1">Weekly catch-up </h6>
                                                        <p className="text-muted mb-0">February, 2024</p>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <p className="text-muted mb-0">02:00 <span className="text-uppercase">pm</span></p>
                                                    </div>
                                                </div>{/* <!-- end --> */}
                                                <div className="mini-stats-wid d-flex align-items-center mt-3">
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <span className="mini-stat-icon avatar-title rounded-circle text-success bg-success-subtle fs-4">
                                                            27
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-1">James Bangs (Client) Meeting</h6>
                                                        <p className="text-muted mb-0">August, 2023</p>
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <p className="text-muted mb-0">03:45 <span className="text-uppercase">pm</span></p>
                                                    </div>
                                                </div>{/* <!-- end --> */}

                                                <div className="mt-3 text-center">
                                                    <a href="javascript:void(0);" className="text-muted text-decoration-underline">View all Events</a>
                                                </div>
                                            </>
                                        :
                                            <div className="noresult">
                                                <div className="text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                                    <h5 className="mt-2">Sorry! No Events Found</h5>
                                                    {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                                </div>
                                            </div>
                                        }

                                    </div>{/* <!-- end cardbody --> */}
                                </div>{/* <!-- end card --> */}
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-xl-12">
                                <div className="card card-height-100">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Associations</h4>
                                        <div className="flex-shrink-0">
                                            <div>
                                                {/* <Link to={'/app/associations/admin/members'} type="button" className="btn btn-soft-primary btn-sm">
                                                    View all
                                                </Link> */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- end card header --> */}

                                    <div className="card-body">
                                        {associations.length > 0 ?
                                            <div className="table-responsive table-card">
                                                <table
                                                    className="table table-centered table-hover align-middle table-nowrap mb-0">
                                                    <thead className="table-light text-muted">
                                                        <tr>
                                                            <th className="sort" data-sort="currency_name" scope="col">Association Info</th>
                                                            <th className="sort" data-sort="type" scope="col">Reg. Number</th>
                                                            <th className="sort" data-sort="currency_name" scope="col">Address</th>
                                                            <th className="sort" data-sort="quantity_value" scope="col">Membership Count</th>
                                                            <th className="sort" data-sort="level" scope="col">Year of Establishment</th>
                                                            <th className="sort" data-sort="status" scope="col">Membership Mode</th>
                                                            <th className="sort" data-sort="status" scope="col">Membership Status</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {associations.map(association => (
                                                            <tr key={association?.id}>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <div className="flex-shrink-0 me-2">
                                                                            <img src="/assets/images/companies/img-1.png"
                                                                                alt="" className="avatar-sm p-2" />
                                                                        </div>
                                                                        <div>
                                                                            <span className="m-0">{association?.name}</span>
                                                                            <p className="m-0 text-muted" style={{lineHeight: 1.5}}>{association?.email}</p>
                                                                            <p className="m-0 text-muted" style={{lineHeight: 1.5}}>{association?.phone}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                 <td>
                                                                    <span className="badge bg-primary">
                                                                        {association?.reg_number ? association?.reg_number : '-'}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                   <p>{association?.address || '-'}</p>
                                                                   {(association?.city || association?.state) && (<p>{association?.city?.name}, {association?.state?.name},</p>)}
                                                                   {association?.country && (<p>{association?.country?.name}</p>)}
                                                                </td>
                                                                {/* <td>
                                                                    <span className="badge bg-info-subtle text-info">
                                                                        {association.membership_id ? association.membership_id : '-'}
                                                                    </span>
                                                                </td> */}
                                                                <td>
                                                                    {association?.member_count || '0'}
                                                                </td>
                                                                <td>
                                                                    {association?.year_established || '-'}
                                                                </td>
                                                                <td>
                                                                    <span className={`badge ${association?.membership_mode == 'free' ? 'bg-success-subtle text-secondary' : association?.membership_mode == 'paid'? 'bg-success-subtle text-info' : 'bg-danger-subtle text-danger'
                                                                        } text-uppercase`}
                                                                    >{association?.membership_mode || 'Not defined yet'}</span>
                                                                </td>
                                                                <td>
                                                                    <span className={`badge ${association?.membership_status == 'open' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                                                                        } text-uppercase`}
                                                                    >{association?.membership_status}</span>
                                                                </td>
                                                                <td>
                                                                    <div className="dropdown">
                                                                        <button className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <i className="ri-more-fill"></i>
                                                                        </button>
                                                                        <ul className="dropdown-menu">
                                                                            <li onClick={() => setCurrentAssociation(association)} data-bs-toggle="offcanvas" data-bs-target="#member-view-offcanvas"><a className="dropdown-item cursor-pointer"><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View</a></li>
                                                                            {/* <li><a className="dropdown-item" href="javascript:void(0);"><i className="ri-star-fill text-muted me-2 align-bottom"></i>Renew Membership</a></li> */}
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {/* <!-- end --> */}
                                                    </tbody>
                                                </table>
                                                {/* <!-- end table --> */}
                                            </div>
                                        :
                                            <div className="noresult">
                                                <div className="text-center">
                                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                    {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {/* <!-- .card-body--> */}
                                </div>
                                {/* <!-- .card--> */}
                            </div>
                            {/* <!-- .col--> */}
                        </div>
                        {/* <!-- end row--> */}

                    </div>
                    {/* <!-- end .h-100--> */}

                </div>
                {/* <!-- end col --> */}

                {/* <!-- end col --> */}
                {loading && <Loader />}
            </div>

            {/* <!-- Member View --> */}
            <div className="offcanvas offcanvas-end border-0" tabindex="-1" id="member-view-offcanvas">
                <div className="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header">
                    <h5 className="m-0 me-2 text-white">Member Profile</h5>

                    <button type="button" className="btn-close btn-close-white ms-auto" id="customizerclose-btn"
                        data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body p-0 bg-light">
                    <div data-simplebar className="h-100">
                        <div className="p-4">
                            {/* <Details userId={currentMember?.user_id}/> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}